const forms = require('../components/forms');
const expandInteraction = require('../interactions/expand');

function toggleDropDownCheck($dropDownCheck) {
  const isOpen = !$dropDownCheck.hasClass('drop-down-check--opened');

  const $toggler = $dropDownCheck.children('.drop-down-check__toggler');
  const content = $dropDownCheck.children('.drop-down-check__content').get(0);
  if (!content) return;

  const $form = $($dropDownCheck).is('form') ? $dropDownCheck : $dropDownCheck.find('form');
  $form.each(function clearEachFormErrors() {
    forms.clearFormErrors(this);
  });

  if (isOpen) {
    $dropDownCheck.addClass('drop-down-check--opened');
    $('.btn-radio', $toggler).addClass('btn-radio--opened');
  } else {
    $dropDownCheck.removeClass('drop-down-check--opened');
    $('.btn-radio', $toggler).removeClass('btn-radio--opened');
  }

  /*  probably deprecated
  let container = $dropDownCheck.closest('.drop-down-check-container');
  if (container.length === 0) {
    container = $dropDownCheck.parent();
  }

  if (content.hasClass('transition-m2')) {
    $('body').trigger('transition-m2', [content[0], isOpen, container[0]]);
  }
  */

  if (content.classList.contains('interaction--expand')) {
    expandInteraction.toggle(content);
  }
}

module.exports = {
  init: () => {
    $('body').on('click', '.drop-down-check__toggler', function handleDropdownTogglerClick() {
      const $component = $(this).closest('.drop-down-check');
      toggleDropDownCheck($component);
    });

    $('body').on('drop-down-check-content:toggle', (event, response) => {
      toggleDropDownCheck(response.block);
    });

    $('body').on('drop-down-check-content:set-height', (event, response) => {
      const contentElement = $('.drop-down-check__content', response.block)[0];
      expandInteraction.calculateHeight(contentElement);
    });
  },
  handleInitialExpandedClass(dropDownCheckButton, dropDownCheckContent) {
    const initialExpanded = dropDownCheckButton.hasClass('btn-radio--opened');
    if (initialExpanded) {
      dropDownCheckContent.addClass('interaction--initially-expanded interaction-active');
    }
  },
};
